export const advantagesItems = [
  {
    image: '/images/aboutUsPage/star.webp',
    text: 'Высокое качество продукции',
    description:
      'Продукция SCT Germany соответствует мировым стандартам и проходит строгие тестирования',
  },
  {
    image: '/images/aboutUsPage/cell.webp',
    text: 'Широкий ассортимент автозапчастей',
    description:
      'В наличии фильтры, тормозные колодки, масла и многое другое для автомобилей любых марок',
  },
  {
    image: '/images/aboutUsPage/calendar.webp',
    text: 'Долговечность и износостойкость',
    description: 'Компоненты SCT рассчитаны на длительную эксплуатацию и устойчивы к износу',
  },
  {
    image: '/images/aboutUsPage/basket.webp',
    text: 'Удобство покупки и быстрая доставка',
    description: 'Легко оформляйте заказы онлайн и получайте их в кратчайшие сроки',
  },
  {
    image: '/images/aboutUsPage/car.webp',
    text: 'Эффективная защита компонентов автомобиля',
    description:
      'Фильтры и другие запчасти SCT защищают двигатель и системы автомобиля от загрязнений',
  },
  {
    image: '/images/aboutUsPage/box.webp',
    text: 'Экологически чистые решения',
    description:
      'SCT Germany уделяет особое внимание экологии, предлагая продукцию, уменьшающую воздействие на окружающую среду',
  },
];
